const useTextInputValidation = (fieldName, validationRules = []) => {
  const validate = val => {
    let errorList = []
    const rules = [...validationRules]
    const label = fieldName.replace('*', '')
    const decimalNumberRegex = /^-?\d*\.?\d+$/
    rules.forEach(rule => {
      if (rule.type === 'required' && !val.trim()) {
        errorList.push(`${label}  ${rule.msg}`)
      }
      if (rule.type === 'number' && isNaN(val)) {
        errorList.push(`${label} ${rule.msg}`)
      }
      if (rule.type === 'maxLength' && val.length > rule.limit) {
        errorList.push(`${label} ${rule.msg}`)
      }
      if (rule.type === 'minLength' && val.length < rule.limit) {
        errorList.push(`${label} ${rule.msg}`)
      }
      if (rule.type === 'pattern' && !new RegExp(rule.regex).test(val)) {
        errorList.push(`${label} ${rule.msg}`)
      }
      if (rule.type === 'decimal' && !decimalNumberRegex.test(val)) {
        errorList.push(`${label} ${rule.msg}`)
      }
    })

    return errorList[0]
  }

  const onChange = e => {
    return validate(e)
  }

  return {onChange}
}

export default useTextInputValidation
